import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-dropdown',
    templateUrl: './dropdown.component.html',
    standalone: false
})
export class DropdownComponent {

  @Input() dropdownItems: any;
  @Input() class: string;
  @Output() dropdownEmitData = new EventEmitter();
  ngOnInit(): void {
  }


  dropdownItemsEvents(data) {
    this.dropdownEmitData.emit(data);
  }
  
}
